import React from "react";
import { Box, Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import moment from "moment";

// Fecha, observaciones y check "Para Cambio".
export default function DatosPedidoForm({
  datosPedido,
  onChange,
  pedidoCambio,
  onPedidoCambioChange,
}) {
  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "5px",
        padding: "10px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        backgroundColor: "#f9f9f9",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={3}>
          <TextField
            fullWidth={true}
            focused
            size="small"
            type="datetime-local"
            required
            placeholder="Fecha "
            name="fecha_para"
            label="Fecha de Pedido"
            variant="outlined"
            value={moment(datosPedido.fecha_para).format("YYYY-MM-DDTHH:mm")}
            onChange={onChange}
          />
        </Grid>
        <Grid item xs={7.5}>
          <TextField
            label="Observaciones"
            name="observaciones"
            size="small"
            focused
            fullWidth
            autoComplete="off"
            value={datosPedido.observaciones}
            onChange={onChange}
          />
        </Grid>
        <Grid item xs={1.5}>
          <FormControlLabel
            control={
              <Checkbox
                checked={pedidoCambio}
                onChange={onPedidoCambioChange}
                inputProps={{ "aria-label": "controlled" }}
              />
            }
            label="Para Cambio"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
